import { getCMSConfiguration } from '../../cms/cmsLib';

//import i18n from "../../services/i18n.js";

const styleIcon = {
    color: 'inherit',
    fontWeight: 300
};

/**
 * Restriccion en los elementos del menu.
 * https://xcaleconsulting.atlassian.net/wiki/spaces/OL/pages/647692308/UI+-+Navigation+Menu
 *
 * @param {Array de strings} authorities
 * @param {Permiso requerido} regExp
 */
export function checkAuthorities(authorities, regExp) {
    if (regExp !== undefined) {
        if (regExp === '') {
            return true;
        } else {
            //OLYB2B-438
            let allauth = authorities.join(',');
            let permisomenu = RegExp(regExp, 'gi');
            return permisomenu.test(allauth);
        }
    }
    return false;
}
/**
 *  Funcion que valida el acceso segun la url o path principal de la pagina.
 * 
 * @param {*} authorities array de authorizaciones permitidas para el usuario.
 * @param {*} page pagina actual sin el hash
 */
export function checkAuthoritiesForPath(links, page) {
    //OLYB2B-438
    let pages = (links || []).filter(menu => menu.href === '/#/' + page);
    return pages.length > 0;
}
/**
 * Metodo que descubre la primera URL a la que puedo acceder y navega.
 */
export function navigateToFirstAllowedUrl(user, subPage, callBackFunction) {
    subPage = (!subPage) ? '' : '/' + subPage;
    let cmsConf = getCMSConfiguration();
    if (cmsConf) {

        const webTabs = cmsConf['tabs'];

        subPage = `/${webTabs[0] ? webTabs[0].orden : ''}`;
        let pages = cmsConf.links;
        const redirectTo = localStorage.getItem('redirectTo');
        if (redirectTo && redirectTo.indexOf('hotelsparams') !== -1) {
            window.location.href = localStorage.getItem('redirectTo');
        } else {
            const thepage = pages && pages.length ? pages[0].href + subPage : '/#/noauth/forpage=Login';
            window.location.href = thepage;
        }
    } else {
        window.location.href = '#/Login';
    }
    if (callBackFunction) {
        setTimeout(() => callBackFunction(), 400);
    }
}


// WEBPACK FOOTER //
// ./src/components/SideBar/menudataprovider.js